//@ts-check
import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import deepMerge from '../utils/deepMerge';

var LocalTheme = function LocalTheme(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  var localTheme = React.useMemo(function () {
    return function (t) {
      return deepMerge(t, theme);
    };
  }, [deepMerge, theme]);
  if (!theme) return children;
  return React.createElement(MuiThemeProvider, {
    theme: localTheme
  }, children);
};

export default LocalTheme;